import { useForm, zodResolver } from '@mantine/form';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PageContainer,
  PageFooter,
  PageHeader,
  SimpleStepDots,
  StepProps,
} from '../../../shared_components';
import {
  Flex,
  NumberInput,
  SegmentedControl,
  Space,
  Stack,
} from '@mantine/core';
import EastIcon from '@mui/icons-material/East';
import { observer } from 'mobx-react-lite';
import { Gender } from '@web/common';
import classes from '../../../app.module.css';
import {
  healthData,
  HealthData,
  useUserDataStore,
} from '../../../shared_stores';

export const StepHealthData = observer(
  ({ forward, back, step = 0, max = 0 }: StepProps) => {
    const { t } = useTranslation(['registration', 'common']);
    const userDataStore = useUserDataStore();
    const [isValid, setIsValid] = useState(
      userDataStore.healthData !== undefined,
    );
    const form = useForm<HealthData>({
      initialValues: userDataStore.healthData,
      validateInputOnBlur: true,
      validate: zodResolver(healthData),
    });

    useEffect(() => {
      form.setFieldValue('gender', Gender.male);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = () => {
      if (form.isDirty()) {
        userDataStore.setStoreDirty(true);
      }
      setIsValid(form.isValid());
    };

    const handleSubmit = () => {
      userDataStore.setHealthData(form.getValues());
      forward();
    };

    return (
      <PageContainer>
        <form
          onChange={handleChange}
          onSubmit={form.onSubmit(handleSubmit, console.log)}
        >
          <Flex direction={'column'} justify={'space-between'} h={'100%'}>
            <Stack
              gap={'var(--mantine-spacing-xs)'}
              classNames={{ root: classes.footerPadding }}
            >
              <PageHeader
                title={t('health_data_title')}
                message={t('health_data_message')}
                topElement={
                  <SimpleStepDots step={step} max={max} text={false} />
                }
              />
              <NumberInput
                label={t('body_height')}
                placeholder={t('body_height')}
                key={form.key('height')}
                {...form.getInputProps('height')}
              />
              <NumberInput
                label={t('year_of_birth')}
                placeholder={t('year_of_birth')}
                key={form.key('year_of_birth')}
                {...form.getInputProps('yearOfBirth')}
              />
              <Space />
              <SegmentedControl
                data={[
                  { value: Gender.male, label: t('gender_male') },
                  { value: Gender.female, label: t('gender_female') },
                  { value: Gender.nonbinary, label: t('gender_other') },
                ]}
                key={form.key('gender')}
                {...form.getInputProps('gender')}
              />
            </Stack>
            <PageFooter
              leftOnClick={back}
              buttonText={t('continue')}
              buttonIcon={<EastIcon />}
              submitButton={true}
              disabled={!isValid}
            />
          </Flex>
        </form>
      </PageContainer>
    );
  },
);
